var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVisibilityOn = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0015 2C11.5962 2 14.5869 4.58651 15.2139 8C14.5869 11.4135 11.5962 14 8.0015 14C4.40672 14 1.41607 11.4135 0.789062 8C1.41607 4.58651 4.40672 2 8.0015 2ZM8.0015 12.6667C10.8252 12.6667 13.2415 10.7013 13.8531 8C13.2415 5.29869 10.8252 3.33333 8.0015 3.33333C5.1777 3.33333 2.76145 5.29869 2.14982 8C2.76145 10.7013 5.1777 12.6667 8.0015 12.6667ZM8.0015 11C6.34462 11 5.00148 9.65687 5.00148 8C5.00148 6.34315 6.34462 5 8.0015 5C9.6583 5 11.0015 6.34315 11.0015 8C11.0015 9.65687 9.6583 11 8.0015 11ZM8.0015 9.66667C8.92197 9.66667 9.66817 8.92047 9.66817 8C9.66817 7.07953 8.92197 6.33333 8.0015 6.33333C7.08104 6.33333 6.33481 7.07953 6.33481 8C6.33481 8.92047 7.08104 9.66667 8.0015 9.66667Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVisibilityOn, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/visibility_on.26563d72.svg";
export { ForwardRef as ReactComponent };